type SyncCallbackType = () => Promise<any> | void

export default class SyncCallbackRunner {
  private _running: boolean = false
  private _callbacks: SyncCallbackType[] = []

  execute(command: SyncCallbackType) {
    this._callbacks.push(command)
    this.run()
  }

  private async run() {
    if (this._running || this._callbacks.length === 0) {
      return
    }

    this._running = true
    while (this._callbacks.length > 0) {
      const callback = this._callbacks.shift()
      const maybePromise = callback()
      if (!!maybePromise && !!maybePromise.then) {
        await maybePromise
      }
    }
    this._running = false
  }
}
